import React from 'react';
import widgets from '../../../images/icons/widgets.svg';
import JsTag from './jstag';
import './widgets.scss';

const Widgets = () => {
  return (
    <div className="widgets">
      <div className="card-container">
        <div className="flex-center">
          <h1>Widgets</h1>
          <img src={widgets} alt="config-icon" />
        </div>
        <JsTag />
      </div>
    </div>
  );
};

export default Widgets;
